webpackJsonp([229268004393940],{

/***/ 481:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.pageQuery = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _graphql = __webpack_require__(15);
	
	var _graphql2 = _interopRequireDefault(_graphql);
	
	var _ptzI18n = __webpack_require__(14);
	
	var _gatsbyLink = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var RedirectIndex = function (_React$PureComponent) {
	  _inherits(RedirectIndex, _React$PureComponent);
	
	  function RedirectIndex(args) {
	    _classCallCheck(this, RedirectIndex);
	
	    var _this = _possibleConstructorReturn(this, _React$PureComponent.call(this, args));
	
	    if (typeof window !== 'undefined') {
	      var url = args.location.pathname;
	      var _args$data$site$siteM = args.data.site.siteMetadata.languages,
	          langs = _args$data$site$siteM.langs,
	          defaultLangKey = _args$data$site$siteM.defaultLangKey;
	
	      var langKey = (0, _ptzI18n.getUserLangKey)(langs, defaultLangKey);
	      var homeUrl = (0, _gatsbyLink.withPrefix)('/' + langKey + url);
	
	      window.___history.replace(homeUrl);
	    }
	    return _this;
	  }
	
	  RedirectIndex.prototype.render = function render() {
	    return _react2.default.createElement('div', null);
	  };
	
	  return RedirectIndex;
	}(_react2.default.PureComponent);
	
	exports.default = RedirectIndex;
	var pageQuery = exports.pageQuery = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-help-us-translate-index-js-7adcbd9df8f1f5cdc834.js